import { useCallback } from 'react'
import { OrderFile } from '../../../../../../services'
import { notification } from 'antd'
import { useIntl } from 'react-intl'

const MAX_PROPOSAL_FILES_COUNT = 10 // check value in messages on change!

function getRandomId(): number {
  return Math.round(Math.random() * 10000000)
}

type UseProposalFilesViewParams = {
  proposalFiles: Array<OrderFile>;
  onAttachFiles: (files: Array<File>) => void;
}

export function useProposalFilesView({ proposalFiles, onAttachFiles }: UseProposalFilesViewParams) {
  const fileNames = proposalFiles.map(file => file.filename)
  const intl = useIntl()

  const onUploadFiles = useCallback((files: Array<File>) => {
    if (files.length + fileNames.length > MAX_PROPOSAL_FILES_COUNT) {
      notification.error({
        message: `${intl.messages['externalSourceProposal.proposalFiles.toManyFiles']} ${MAX_PROPOSAL_FILES_COUNT}`,
        duration: 5,
      })
      return
    }

    const noCollisionFiles = files.map(file => {
      const blob = file.slice(0, file.size, file.type)
      const fileParts = file.name.split('.')
      const newFileName = `${fileParts[0]}-${Date.now()}.${fileParts[fileParts.length - 1]}`
      return new File(
        [blob],
        newFileName,
        { type: file.type },
      )
    })

    onAttachFiles(noCollisionFiles)
  }, [onAttachFiles, fileNames, intl])

  return {
    onUploadFiles,
  }
}
